import { ModelPsAgreementTemplate } from '../../models/fireModels/types'

export class AgreementTemplateSelectService {
  templates: AgreementTemplateDTO[] = []
  initPromise: Promise<void>
  constructor() {
    this.initPromise = this.init()
  }

  async init() {
    const filter: any = {
      _or: [
        {
          restrict_clinics: { _eq: false },
          status: { _eq: '公開'},
        },
      ]
    }
    const clinicId = $core.$embAuth.user?.ps_clinic?.id

    if (clinicId) {
      filter._or.push({
        restrict_clinics: { _eq: true },
        status: { _eq: '公開' },
        available_clinics: {
          clinic: { _eq: clinicId }
        }
      })
    }
    const templates = await $core.$models.ps_agreement_template.find({
      filter: filter,
      sort: ['sort']
    })
    this.templates = templates.map(template => new AgreementTemplateDTO(template))
  }
}

export class AgreementTemplateDTO {
  constructor(public data: ModelPsAgreementTemplate) {}
  get id() {
    return this.data.id
  }
  get thumbImgUrl() {
    if (this.data.thumb_img) {
      return $core.$imgix?.buildUrl(this.data.thumb_img)
    }
    return null
  }
  openPreviewAsModal(userInputArgs: Record<string, any>) {
    
  }
}
